import type { ReactNode } from "react"
import { Check } from "lucide-react"
import { cn } from "@/lib/utils"

// Small check-icon badge that's pinned to the top-right of an
// autosaved field. Always mounted; only opacity flips so the fade-out
// is smooth. Pair with `useFieldSaveIndicator` — render this inside a
// `relative` wrapper with `visible={savedKey === "your-field-key"}`.
export function SavedCheck({ visible }: { visible: boolean }) {
  return (
    <span
      aria-hidden={!visible}
      title="Saved"
      className={cn(
        "pointer-events-none absolute right-2 top-2 z-10 inline-flex items-center justify-center rounded-full bg-page p-0.5 text-emerald-600 transition-opacity duration-500",
        visible ? "opacity-100" : "opacity-0",
      )}
    >
      <Check className="h-3.5 w-3.5" />
    </span>
  )
}

// Wraps a single autosaved field with a relative positioning context
// and the SavedCheck overlay. Use to avoid repeating
// `<div className="relative"> … <SavedCheck /> </div>` at every site.
export function SavedField({
  children,
  visible,
}: {
  children: ReactNode
  visible: boolean
}) {
  return (
    <div className="relative">
      {children}
      <SavedCheck visible={visible} />
    </div>
  )
}
